import { isEqual } from 'lodash';
import { DependencyList, useRef } from 'react';

type MemoRef<T> = {
  value: T;
  deps: DependencyList | undefined;
};

export function useDeepMemo<T>(factory: () => T, deps: DependencyList | undefined): T {
  const ref = useRef<MemoRef<T>>();
  if (ref.current === undefined || isEqual(deps, ref.current.deps) === false) {
    ref.current = { value: factory(), deps };
  }
  return ref.current.value;
}
